import { Platform, useWindowDimensions } from "react-native";

const MAX_APP_WIDTH = 480;

/**
 * Returns layout helpers for constraining the app column on wide web screens.
 *
 * columnStyle  — apply to the root scroll container (maxWidth + centering)
 * isWideScreen — true when the browser is wider than MAX_APP_WIDTH
 * appWidth     — the effective app column width (capped at MAX_APP_WIDTH)
 */
export function useWebLayout() {
  const { width } = useWindowDimensions();

  if (Platform.OS !== "web") {
    return { columnStyle: {}, isWideScreen: false, appWidth: width };
  }

  const isWideScreen = width > MAX_APP_WIDTH;

  // const columnStyle = isWideScreen
  //   ? { maxWidth: MAX_APP_WIDTH, marginHorizontal: "auto", boxShadow: "0 0 40px rgba(0,0,0,0.25)" }
  //   : {};
  const columnStyle = isWideScreen
    ? { width: MAX_APP_WIDTH,maxWidth: MAX_APP_WIDTH, marginHorizontal: "auto", boxShadow: "0 0 5px rgba(0,0,0,0.15)" }
    : {};

  const appWidth = Math.min(width, MAX_APP_WIDTH);

  return { columnStyle, isWideScreen, appWidth };
}
